import { SHORTCUT_TRIGGERED_EVENT, type ShortcutKey } from "@/utility/key-shortcuts/shortcuts";
import { useEffect, useState } from "react";

const ANIMATION_DURATION = 150;

export const useRecentShortcut = (shortcutKey: ShortcutKey) => {
  const [isRecent, setIsRecent] = useState(false);

  useEffect(() => {
    const handleShortcut = (event: CustomEvent<{ shortcut: ShortcutKey }>) => {
      if (event.detail.shortcut === shortcutKey) {
        setIsRecent(true);
        setTimeout(() => {
          setIsRecent(false);
        }, ANIMATION_DURATION);
      }
    };

    document.addEventListener(SHORTCUT_TRIGGERED_EVENT as any, handleShortcut);
    return () => {
      document.removeEventListener(SHORTCUT_TRIGGERED_EVENT as any, handleShortcut);
    };
  }, [shortcutKey]);

  return isRecent;
};
